import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  bModeSelector,
  chatCommandSelector,
  chatIsEnabledSelector,
  messageSelector,
  searchIsOpenSelector,
  setBMode,
  setIndexMessageBySearch,
  setOpenSearch,
  setSearchValue,
  setUidMessagesBySearch,
  tooltipCommandsAllSelector,
  tooltipCommandsPositionSelector,
  tooltipCommandsSelector,
} from "@/domains/chat/slice";
import useInputEvent from "@/domains/chat/hooks/useInputEvent";
import ChatInput from "@/domains/chat/components/chat/ChatInput";
import { appliedChatSettingsSelector } from "@/domains/settings/chat/slice";

type Props = {
  show: boolean;
};

function ChatInputContainer({ show }: Props) {
  const dispatch = useAppDispatch();
  const message = useAppSelector(messageSelector);
  const isEnabled = useAppSelector(chatIsEnabledSelector);
  const command = useAppSelector(chatCommandSelector);
  const tooltipCommands = useAppSelector((state) => tooltipCommandsSelector(state, message));
  const tooltipCommandsAll = useAppSelector(tooltipCommandsAllSelector);
  const tooltipCommandsPosition = useAppSelector(tooltipCommandsPositionSelector);
  const isBMode = useAppSelector(bModeSelector);
  const { showCommandTooltip } = useAppSelector(appliedChatSettingsSelector);
  const searchIsOpen = useAppSelector(searchIsOpenSelector);
  const { onBlur, onFocus, onMessageChange, onMessageSubmit, onKeyDown, onChangeCommand } =
    useInputEvent();

  const toggleShowSearch = useCallback(() => {
    if (searchIsOpen) {
      dispatch(setOpenSearch(false));
      dispatch(setSearchValue(""));
      dispatch(setIndexMessageBySearch(-1));
      dispatch(setUidMessagesBySearch([]));
    } else {
      dispatch(setOpenSearch(!searchIsOpen));
      if (message) {
        dispatch(setSearchValue(message));
      }
    }
  }, [searchIsOpen, dispatch, message]);

  return (
    <ChatInput
      message={message}
      onSubmit={onMessageSubmit}
      onChange={onMessageChange}
      isEnabled={isEnabled}
      command={command}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      showTooltip={showCommandTooltip}
      tooltipCommands={tooltipCommands}
      tooltipCommandsAll={tooltipCommandsAll}
      tooltipCommandsPosition={tooltipCommandsPosition}
      onChangeCommand={onChangeCommand}
      isBMode={isBMode}
      onChangeBMode={() => dispatch(setBMode(!isBMode))}
      show={show}
      onToogleSearch={toggleShowSearch}
    />
  );
}
export default ChatInputContainer;
